<div style="display: inline-block">
  <form [formGroup]="form" class="grid">
    <mat-form-field>
      <mat-select formControlName="sign">
        <mat-option value="+">+</mat-option>
        <mat-option value="-">-</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'QUERY_BUILDER.value' | translate }}</mat-label>
      <input formControlName="value"
             type="number"
             matInput>
    </mat-form-field>

    <mat-form-field>
      <mat-select formControlName="unit">
        <mat-option value="minutes">{{ 'CONTROLS.minutes' | translate }}</mat-option>
        <mat-option value="days">{{ 'CONTROLS.days' | translate }}</mat-option>
        <mat-option value="months">{{ 'CONTROLS.months' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{rule.value}}</mat-label>
      <input formControlName="time" type="time" step="1" matInput>
    </mat-form-field>
  </form>
</div>
